import { AbstractMedia } from 'types/AbstractMedia';
import type { MayBe } from 'types/common';
import { Orientation } from 'hooks/useOrientation';

const resolveBackgroundMedia = (
  orientation: Orientation,
  landscapeMedia: MayBe<AbstractMedia>,
  portraitMedia: MayBe<AbstractMedia>,
): MayBe<AbstractMedia> => {
  const primary = orientation === Orientation.PORTRAIT ? portraitMedia : landscapeMedia;
  const fallback = orientation === Orientation.PORTRAIT ? landscapeMedia : portraitMedia;
  return primary ?? fallback;
};

export default resolveBackgroundMedia;
